app.controller('LoginController', ['$rootScope', '$scope', '$state', '$location', function ($rootScope, $scope, $state, $location) {

    $scope.form_disabled = false;

    $scope.is_new_registration = !!$location.search()['is_new_registration'];

    $scope.login_data = {
        username: "",
        password: ""
    }

    $scope.loginUser = function (validateFormCallback) {

        $scope.form_disabled = true;
        $rootScope.service.account.loginUser($scope.login_data, function (success, data, messages) {

            if (success) {
                $rootScope.model.account.is_login_required = false;
                console.log($state?.current?.name ?? "")
                if(["myba", "myba.login", "", "login"].includes($state?.current?.name ?? "")) {
                    $rootScope.service.tracking.track_event("Login status", "Log in");
                    if ($rootScope.model.staff.is_staff_or_rep) {
                        $state.go('myba.staff-customer');
                    } else {
                        $state.go('myba.dashboard');

                    }
                }
            } else {
                $scope.form_disabled = false;
            }

            validateFormCallback(success, messages);
        });
    };

}]);